<template>
  <div class="page-container">
    <div>
      <section class="page-header">
        <h2 class="font-weight-bold">Gestão de conteúdos</h2>
      </section>

      <div class="separator-line"></div>
      <section class="sub-header">
        <p class="color-green-2 p3">Faça a gestão de conteúdos do portal.</p>
      </section>
    </div>
    <section>
      <div class="card-container">
        <CustomInfoCard
          class="deck deck-margin"
          v-for="card in getCards"
          :key="card.id"
          :onCardClick="() => onClickCard(card)"
          :headerIcon="card.headerIcon"
          :title="card.header"
          :description="card.description"
          :icon="card.icon"
          :featureName="card.featureName"
        />
      </div>
    </section>
  </div>
</template>

<script>
import CustomInfoCard from "../../../components/custom-info-card/CustomInfoCard.vue";
import RoutesPaths from "../../../router/router-structure/routes-paths";
import { isMobile } from "../../../utils/mobile/mobile";

export default {
  components: {
    CustomInfoCard,
  },
  computed: {
    getCards: () => {
      let cards = [
        {
          id: 0,
          icon: "MDI-folder-upload-outline.svg",
          header: "Gerenciamento de arquivos",
          description:
            "Realize o processo de envio, edição e exclusão de arquivos",
          route: RoutesPaths.fileManagement.rootName(),
          showMobile: true,
          featureName: "HOME_CARD_CONTENT_MANAGEMENT_FILE",
        },
        // {
        //   id: 1,
        //   icon: "MDI-communication-management.svg",
        //   header: "Gestão de Comunicados",
        //   description:
        //     "Crie e gerencie comunicados que serão exibidos no portal para os Cooperados",
        //   route: RoutesPaths.communicationManagement.rootName(),
        //   showMobile: true,
        //   featureName: "HOME_CARD_COMMUNICATION_MANAGEMENT",
        // },
        // {
        //   id: 2,
        //   icon: "MDI-calendar-check.svg",
        //   header: "Participação Assembleia",
        //   description: "Registre a participação dos cooperados nas assembleias",
        //   route: RoutesPaths.contentManagement.assemblyManagement(),
        //   showMobile: true,
        //   featureName: "HOME_CARD_CONTENT_MANAGEMENT_ASSEMBLY",
        // },
      ];
      if (isMobile()) {
        return cards.filter((c) => c.showMobile);
      }
      return cards;
    },
  },
  methods: {
    isMobile: isMobile,
    onClickCard({ route, link }) {
      if (link) {
        window.open(link, "_blank");
      } else if (route) this.$router.push(route);
    },
  },
};
</script>

<style lang="scss" scoped>
.deck-margin {
  margin: 2rem;
}

.page-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.page-header {
  text-align: center;
}

.sub-header {
  max-width: 83rem;
  margin: 0 auto;
  margin-top: 1.5rem;
  text-align: center;
}

.card-container {
  max-width: 100rem;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @include media-breakpoint-up(xs) {
    justify-content: center;
  }

  @include media-breakpoint-up(md) {
    justify-content: center;
  }
}

.pointer {
  cursor: pointer;
}
</style>
